import { connect } from "react-redux";
import RequestExternal from "./requestExternal";
import { bindActionCreators } from "redux";
import {walletListing} from "services/redux/Wallet/action";

const mapStateToProps = (state) => ({
    listing : state.Wallet.listing,
});

const mapDispatchToProps = (dispatch) =>
    bindActionCreators({
        walletListing
    }, dispatch);

export default connect(mapStateToProps, mapDispatchToProps)(RequestExternal);